import { Controller } from "@hotwired/stimulus"

// Schede (Radix Tabs). Trigger con data-tabs-value-param, pannelli con data-tab-value.
// Con data-tabs-param-value="nome" la scheda attiva va anche nell'URL (?nome=…), come facevano le pagine React.
export default class extends Controller {
  static targets = ["trigger", "panel"]
  static values = { active: String, param: String, replace: Boolean }

  connect() {
    let fromUrl = this.paramValue && new URLSearchParams(window.location.search).get(this.paramValue)
    // un valore dell'indirizzo che non e' una scheda non vale (con data-tabs-replace-value: la scheda del server)
    if (this.replaceValue && !this.triggerTargets.some((t) => t.dataset.tabsValueParam === fromUrl)) fromUrl = null
    this.show(fromUrl || this.activeValue || this.triggerTargets[0]?.dataset.tabsValueParam)
    // data-tabs-replace-value: la scheda scelta dal server entra subito nell'indirizzo (setSearchParams(..., {replace: true}))
    if (this.replaceValue && this.paramValue && !fromUrl && this.activeValue) this.scriviUrl(this.activeValue)
  }

  select(event) {
    this.show(event.params.value)
    if (this.paramValue) this.scriviUrl(event.params.value)
    this.dispatch("change", { detail: { value: event.params.value } })
  }

  scriviUrl(value) {
    const url = new URL(window.location.href)
    url.searchParams.set(this.paramValue, value)
    history.replaceState(history.state, "", url)
  }

  show(value) {
    this.activeValue = value
    this.triggerTargets.forEach((t) => {
      const on = t.dataset.tabsValueParam === value
      t.dataset.state = on ? "active" : "inactive"
      t.setAttribute("aria-selected", String(on))
    })
    this.panelTargets.forEach((p) => {
      const on = p.dataset.tabValue === value
      p.dataset.state = on ? "active" : "inactive"
      p.hidden = !on
    })
  }
}
